import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  spacing = tokens.spacing;
var _ref = {
  name: "8atqhb",
  styles: "width:100%;"
};
var _ref2 = {
  name: "132diu7",
  styles: "margin:auto 0;"
};
var _ref3 = {
  name: "lte6c0",
  styles: "max-width:60%;"
};
export var statsButtons = appearance => /*#__PURE__*/css("display:flex;flex-direction:", appearance === 'vertical' ? 'column' : 'row', ";align-items:center;gap:", spacing.l, ";", appearance === 'vertical' && _ref, " ", appearance !== 'vertical' && _ref2, " ", appearance === 'tablet' && _ref3);
var _ref4 = {
  name: "ofjrfz",
  styles: "width:100%;margin-left:10px;"
};
var _ref5 = {
  name: "9nkqab",
  styles: "justify-content:space-between;flex-wrap:wrap;min-width:120px;"
};
export var stats = appearance => /*#__PURE__*/css("display:flex;flex-direction:row;column-gap:20px;", appearance === 'vertical' && _ref4, " ", appearance === 'tablet' && _ref5);
export var stat = {
  name: "axw7ok",
  styles: "display:flex;align-items:center;gap:8px;"
};
var _ref6 = {
  name: "zcxndt",
  styles: "align-items:center;"
};
var _ref7 = {
  name: "zcxndt",
  styles: "align-items:center;"
};
export var statColumn = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;", appearance === 'vertical' && _ref6, " ", appearance === 'horizontal' && _ref7);
export var statValue = /*#__PURE__*/css(designTokenFonts.displaySmall, " color:", colors.neutral.heavy.default, ";");
export var statDescription = /*#__PURE__*/css(designTokenFonts.mini, " color:", colors.neutral.heavy.default, ";");
var _ref8 = {
  name: "1t2w4ts",
  styles: "width:100%;height:94px;justify-content:end;"
};
var _ref9 = {
  name: "l01k19",
  styles: "min-width:272px;"
};
var _ref0 = {
  name: "i06y6t",
  styles: "min-width:180px;"
};
export var buttons = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;gap:8px;z-index:1;", appearance === 'vertical' && _ref8, " ", appearance === 'horizontal' && _ref9, " ", appearance === 'tablet' && _ref0);
var _ref1 = {
  name: "1parb9h",
  styles: "max-width:unset;width:180px;"
};
export var buttonsAgency = appearance => /*#__PURE__*/css(buttons(appearance), " ", appearance === 'tablet' && _ref1);
var _ref10 = {
  name: "tf8u31",
  styles: "max-width:180px;"
};
var _ref11 = {
  name: "y1c3xv",
  styles: "max-height:44px;"
};
var _ref12 = {
  name: "1q4l94b",
  styles: "min-width:175px;"
};
export var button = appearance => /*#__PURE__*/css(designTokenFonts.bodyBold, " width:100%;", appearance === 'tablet' ? _ref10 : _ref11, " .button{", designTokenFonts.bodyBold, " width:100%;", appearance === 'tablet' && _ref12, "}");